
export const ANSWERS = {
	claim: [
		{
			label: `El dia de hoy se hizo el contacto con el paciente para resolver el inconveniente, llegando a una solución. 
							Muchas gracias por ayudarnos a mejorar.`,
			value: `El dia de hoy se hizo el contacto con el paciente para resolver el inconveniente, llegando a una solución. 
      				Muchas gracias por ayudarnos a mejorar.`,
		},
		{
			label: `El dia de hoy intentamos contactarnos con el paciente para resolver el inconveniente en varias oportunidades sin éxito.
      				Le pedimos se comunique a nuestro número telefónico o correo electrónico.
      				Quedamos a la espera para resolver su solicitud.`,
			value: `El dia de hoy intentamos contactarnos con el paciente para resolver el inconveniente en varias oportunidades sin éxito.
      				Le pedimos se comunique a nuestro número telefónico o correo electrónico.
      				Quedamos a la espera para resolver su solicitud.`,
		},
		{
			label: 'Gracias por ayudarnos a mejorar el servicio, tendremos en cuenta su sugerencia.',
			value: 'Gracias por ayudarnos a mejorar el servicio, tendremos en cuenta su sugerencia.',
		},
		{
			label: 'Lamentamos los inconvenientes ocasionados.',
			value: 'Lamentamos los inconvenientes ocasionados.',
		},
		{
			label: 'Otro',
			value: 'Otro',
		},
	],
	suggestion: [
		{
			label: 'Gracias por ayudarnos a mejorar el servicio, tendremos en cuenta su sugerencia.',
			value: 'Gracias por ayudarnos a mejorar el servicio, tendremos en cuenta su sugerencia.',
		},
		{
			label: 'Lamentamos los inconvenientes ocasionados.',
			value: 'Lamentamos los inconvenientes ocasionados.',
		},
		{
			label: 'Otro',
			value: 'Otro',
		},
	],
	congratulations: [
		{
			label: 'Nos alegra haberte brindado una buena experiencia, tendremos en cuenta su sugerencia para mejorar el servicio.',
			value: 'Nos alegra haberte brindado una buena experiencia, tendremos en cuenta su sugerencia para mejorar el servicio.',
		},
		{
			label: 'Nos alegra haberte brindado una buena experiencia. Muchas gracias por tu comentario, esperamos volver a verte por aquí.',
			value: 'Nos alegra haberte brindado una buena experiencia. Muchas gracias por tu comentario, esperamos volver a verte por aquí.',
		},
		{
			label: 'Otro',
			value: 'Otro',
		},
	],
};
